import React from 'react'

export function NewCardsIconTable() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M6.33333 0H1C0.447715 0 0 0.447715 0 1V6.33333C0 6.88561 0.447715 7.33333 1 7.33333H6.33333C6.88561 7.33333 7.33333 6.88561 7.33333 6.33333V1C7.33333 0.447715 6.88561 0 6.33333 0Z'
        fill='currentColor'
      />
      <path
        d='M14.9974 0H9.66406C9.11178 0 8.66406 0.447715 8.66406 1V6.33333C8.66406 6.88561 9.11178 7.33333 9.66406 7.33333H14.9974C15.5497 7.33333 15.9974 6.88561 15.9974 6.33333V1C15.9974 0.447715 15.5497 0 14.9974 0Z'
        fill='currentColor'
      />
      <path
        d='M6.33333 8.66699H1C0.447715 8.66699 0 9.11471 0 9.66699V15.0003C0 15.5526 0.447715 16.0003 1 16.0003H6.33333C6.88561 16.0003 7.33333 15.5526 7.33333 15.0003V9.66699C7.33333 9.11471 6.88561 8.66699 6.33333 8.66699Z'
        fill='currentColor'
      />
      <path
        d='M14.9974 8.66699H9.66406C9.11178 8.66699 8.66406 9.11471 8.66406 9.66699V15.0003C8.66406 15.5526 9.11178 16.0003 9.66406 16.0003H14.9974C15.5497 16.0003 15.9974 15.5526 15.9974 15.0003V9.66699C15.9974 9.11471 15.5497 8.66699 14.9974 8.66699Z'
        fill='currentColor'
      />
    </svg>
  )
}
